<template>
  <span>
    <v-btn @click="setDialog(true)" class="ml-1 mt-2" color="primary" small text>show timeline</v-btn>
    <v-dialog max-width="500" v-model="dialog">
      <v-card>
        <v-card-title class="headline font-weight-thin">Pack Timeline</v-card-title>
        <v-card-text class="mt-3"><pack-timeline :pack="record"></pack-timeline></v-card-text>
        <v-card-actions class="pa-4">
          <v-spacer></v-spacer>
          <v-btn @click="setDialog(false)" class="mr-2" outlined>Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </span>
</template>

<script>
import PackTimeline from "./PackTimeline";

export default {
  components: { PackTimeline },
  data() {
    return {
      dialog: false,
    };
  },
  methods: {
    async setDialog(val) {
      this.dialog = val;
    },
  },
  props: {
    record: { required: true, type: Object },
  },
};
</script>
